import { LoadableLazy } from '@confluence/loadable';

export const CancelApprovalModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CancelApprovalModal" */ '../src/Modals/CancelApprovalModal.tsx'
			)
		).CancelApprovalModal,
});
